import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { formatNumber } from '@telerik/kendo-intl';
import { fetchApi } from '../../services/api';
import { DatePicker, DatePickerChangeEvent } from '@progress/kendo-react-dateinputs';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{ }>;

type State = {
    outstandingBalances: ReportData[];
    asOf?: Date;
    isLoading: boolean;
}

type ReportData = {
    AccountID: number;
    AccountName: string;
    Balance: number;
}

class OutstandingBalances extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            outstandingBalances: [],
            isLoading: false,
        }

        this.setAsOf = this.setAsOf.bind(this);
    }

    public componentWillMount() {
        this.getReport();
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Outstanding Balances" />
            <div className="row">
                <div className="col">
                    <h1>Outstanding Balances</h1>
                </div>
                <div className="col">
                    <button type="button" className="btn btn-primary float-right" onClick={() => confirm("Payment reminder emails will be sent to accounts with outstanding balances.  Do you want to continue?") && this.PaymentReminder()} >Email Payment Reminder</button>
                    <DatePicker className="float-right pr-2" title="As Of" value={this.state.asOf} onChange={this.setAsOf} />
                </div>
            </div>
            {this.renderReportTable()}
        </React.Fragment>;
    }

    private renderReportTable() {
        return <table className='table'>
            <thead>
                <tr>
                    <th>Account Name</th>
                    <th>Outstanding Balance</th>
                </tr>
            </thead>
            <tbody>
                {this.state.outstandingBalances.map((outstandingBalance, index) =>
                    <tr key={ index }>
                        <td>
                            <Link to={ `/accounts/${ outstandingBalance.AccountID }/payments` }>
                                {outstandingBalance.AccountName}
                            </Link>
                        </td>
                        <td>{formatNumber(-outstandingBalance.Balance, { style: 'accounting' })}</td>
                    </tr>
                )}
            </tbody>
        </table>;
    }

    private setAsOf(e: DatePickerChangeEvent) {
        this.setState({ asOf: e.value }, this.getReport);
    }

    private PaymentReminder() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID")
        }
        fetchApi('/api/Reports/PaymentReminder', data, 'POST')
            .then((outstandingBalances: ReportData[]) => {
                alert("Emails successfully sent")
            })
    }

    private getReport() {
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID"),
            DateTime: this.state.asOf
        }
        fetchApi('/api/Reports/OutstandingBalances', data, 'POST')
            .then((outstandingBalances: ReportData[]) => {
                this.setState({ outstandingBalances })
            })
    }
}

export default OutstandingBalances;
